import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=95e3aea8&scoped=true&"
import script from "./ProductStock.vue?vue&type=script&lang=js&"
export * from "./ProductStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductStock.vue?vue&type=style&index=0&id=95e3aea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e3aea8",
  null
  
)

export default component.exports